<template>
  <v-dialog v-model="showModal" max-width="700px" persistent>
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        Editar Sucursal
        <v-btn icon @click="$emit('cerrar-modal')">
          <v-icon title="cerrar"> close </v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="px-4 pb-0">
        <v-form ref="formularioModal" :lazy-validation="true">
          <v-row dense class="mt-4">
            <v-col cols="12" sm="4" class="text-right d-flex align-start mt-2">
              <label for="input-sucursal">
                Seleccione una sucursal
                <span class="red--text">*</span>:</label
              >
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                id="input-sucursal"
                v-model="sucursal"
                :items="sucursales"
                item-value="sucursal_id"
                item-text="descripcion_sucursal"
                label="Sucursal *"
                outlined
                dense
                clearable
                disabled
                :rules="[validacion.required]"
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="4" class="text-right d-flex align-start mt-2">
              <label for="input-plazo-minimo"
                >Antigüedad mayor a <span class="red--text">*</span>:</label
              >
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                id="input-plazo-minimo"
                v-model="plazoMinimo"
                label="Mes(es) *"
                outlined
                dense
                type="number"
                :rules="[validacion.required, validacion.numerico]"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="4" class="text-right d-flex align-start mt-2">
              <label for="input-plazo-contrato">
                Plazo contratos a finalizar
                <span class="red--text">*</span>:
              </label>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                id="input-plazo-contrato"
                v-model="plazoContrato"
                label="Mes(es) *"
                outlined
                dense
                type="number"
                :rules="[validacion.required, validacion.numerico]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-end px-6">
        <v-btn
          class="text-capitalize white--text"
          color="primary"
          :loading="loading"
          @click="guardarCambios"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import empresaService from '../../../../Services/empresaService';
import { alertError } from '../../../../utils/alertUtil';

export default {
  name: 'ModalEditarSucursal',

  props: {
    sucursales: {
      type: Array,
      required: true,
    },
    nit: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showModal: false,
      sucursal: '',
      plazoMinimo: null,
      plazoContrato: null,
      sucursalIndex: -1,
      loading: false,
      mostrarValidaciones: false,
      validacion: {
        required: value => {
          if (!this.mostrarValidaciones) return true;
          return (
            (value !== null && value !== undefined && value !== '') ||
            'Este campo es obligatorio'
          );
        },
        numerico: value => {
          if (!this.mostrarValidaciones) return true;
          const valorNumerico = Number(value);
          return (
            (!Number.isNaN(valorNumerico) && valorNumerico > 0) ||
            'El campo debe ser mayor a 0.'
          );
        },
      },
    };
  },

  methods: {
    abrirModal() {
      this.mostrarValidaciones = false;
      this.showModal = true;
    },

    cerrarModal() {
      this.limpiarFiltros();
      this.showModal = false;
    },

    editarItem(item, index) {
      this.sucursalIndex = index;
      this.sucursal = item.sucursal_id;
      this.plazoMinimo = item.plazo_minimo_credito;
      this.plazoContrato = item.plazo_contrato_finalizar;
    },

    async guardarCambios() {
      this.mostrarValidaciones = true;
      this.$nextTick(async () => {
        if (!this.$refs.formularioModal.validate()) {
          return;
        }
        this.loading = true;

        const filtro = { nit: this.nit };
        const buscarEmpresaPorNit = await empresaService.buscarTodos(filtro);
        const empresaResponse = buscarEmpresaPorNit.data?.[0] || null;
        if (!empresaResponse) {
          alertError('Error al obtener los datos de la empresa.');
          this.loading = false;
          return;
        }

        const sucursalesActualizadas = empresaResponse.sucursales.map(
          sucursal => {
            if (sucursal.sucursal_id === this.sucursal) {
              return {
                ...sucursal,
                plazo_contrato_finalizar: Number.parseInt(this.plazoContrato),
                plazo_minimo_credito: Number.parseInt(this.plazoMinimo),
              };
            }
            return sucursal;
          }
        );

        const datosActualizacion = {
          sucursales: this.prepararSucursales(sucursalesActualizadas),
        };

        const response = await empresaService.actualizarPorNit(
          this.nit,
          datosActualizacion
        );
        if (!response) {
          this.loading = false;
          return;
        }
        this.loading = false;
        this.$emit('listar-sucursales');
        this.cerrarModal();
      });
    },

    limpiarFiltros() {
      this.mostrarValidaciones = false;
      this.sucursal = '';
      this.plazoMinimo = null;
      this.plazoContrato = null;
      this.sucursalIndex = -1;
      if (this.$refs.formularioModal) {
        this.$refs.formularioModal.resetValidation();
      }
    },

    limpiarObjeto(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) =>
            value !== null &&
            value !== undefined &&
            !(typeof value === 'number' && Number.isNaN(value))
        )
      );
    },

    prepararSucursales(sucursales) {
      return sucursales.map(sucursal => this.limpiarObjeto(sucursal));
    },
  },
};
</script>
